// extracted by mini-css-extract-plugin
export default {"header":"tkqsY","row":"CPHMl","wrap":"OtB_f","content":"JXTXr","column":"ZTfuE","remove":"wnRaU","title":"I3PHX","body":"y5Ygq","addFilter":"wmBjv","customField":"PsMbJ"};